angular.module('cfn').directive('cfnInputText', [
    '$rootScope',
    '$log',
    function($rootScope, $log) {
      return {
        restrict: 'E',
        scope: {
          model: '=',
          class: '@',
          readonly: '=',
          required: '@',
          change: '&',
          maxLength: '@'
        },
        replace: true,
        template:
          '<input maxlength="{{maxLength}}" type="text" cfn-enter-tab ng-model="model" ng-class="{\'validate[required]\':required&&(readonly!=true)}" ng-readonly="readonly" ng-required="{{required}}"/>',
        link: function(scope, element, attrs) {
          $(element).change(function() {
            ang.apply(scope, function() {
              scope.change();
            });
          });
        }
      };
    }
  ]);
  
  angular.module('cfn').directive('cfnInputEmail', [
    '$rootScope',
    '$log',
    function($rootScope, $log) {
      return {
        restrict: 'E',
        scope: {
          model: '=',
          class: '@',
          readonly: '=',
          required: '@',
          change: '&'
        },
        replace: true,
        template:
          '<input type="email" cfn-enter-tab ng-model="model" class="{{class}}" ng-class="{\'validate[required]\':required&&(readonly!=true)}" ng-readonly="readonly" ng-required="{{required}}"/>',
        link: function(scope, element, attrs) {
          $(element).change(function() {
            ang.apply(scope, function() {
              scope.change();
            });
          });
        }
      };
    }
  ]);
  
  angular.module('cfn').directive('cfnInputZip', [
    'CountryService',
    function(CountryService) {
      return {
        restrict: 'E',
        scope: {
          model: '=',
          country: '=',
          class: '@'
        },
        require: '?ngModel',
        replace: true,
        template:
          '<input ng-pattern="(zip_code_patterns[country] || zip_code_patterns.default)" maxlength="10" class="{{class}}" type="text" ng-model="model" />',
        link: function(scope, elem, attrs, ngModel) {
          scope.$watch('country', function(newVal, oldVal) {
            if (newVal != oldVal && ngModel.$viewValue) {
              ngModel.$setViewValue(ngModel.$viewValue);
            }
          });
          scope.zip_code_patterns = { default: /.*/ };
          CountryService.getCountries().then(function(response) {
            for (var x = 0; x < response.data.length; x++) {
              scope.zip_code_patterns[response.data[x].isoCode] = new RegExp(
                response.data[x].zipCodePattern,
                'i'
              );
            }
          });
        }
      };
    }
  ]);
  
  angular.module('cfn').directive('cfnInputPassword', [
    '$rootScope',
    '$log',
    function($rootScope, $log) {
      return {
        restrict: 'E',
        scope: {
          model: '=',
          class: '@',
          readonly: '=',
          required: '@',
          change: '&'
        },
        replace: true,
        template:
          '<input type="password" cfn-enter-tab ng-model="model"  class="{{class}}" ng-readonly="readonly" ng-required="{{required}}"/>',
        link: function(scope, element, attrs) {
          $(element).change(function() {
            ang.apply(scope, function() {
              scope.change();
            });
          });
        }
      };
    }
  ]);
  angular.module('cfn').directive('cfnInputPosition', [
    '$rootScope',
    '$log',
    function($rootScope, $log) {
      return {
        restrict: 'E',
        scope: {
          model: '=',
          class: '@',
          readonly: '=',
          required: '@',
          change: '&'
        },
        replace: true,
        template:
          '<span><input type="text" cfn-enter-tab ng-model="data.x"  style="width:25px;padding:2px;margin-right:2px;" ng-readonly="readonly" ng-required="{{required}}"/><input type="text" cfn-enter-tab ng-model="data.y"  style="width:25px;padding:2px;margin-right:2px;" ng-readonly="readonly" ng-required="{{required}}"/><input type="text" cfn-enter-tab ng-model="data.z"  style="width:25px;padding:2px;" ng-readonly="readonly" ng-required="{{required}}"/> </span>',
        link: function(scope, element, attrs) {
          scope.$watch('model', function(newVal) {
            if (newVal) {
              scope.data = angular.fromJson(scope.model);
            } else {
              scope.data = {};
            }
          });
  
          scope.updateModel = function() {
            console.debug(' updated data ', scope.data);
            scope.model = angular.toJson(scope.data);
          };
          //TODO: save data, mapper does not correctly map the string ..
          $('input', element).change(function() {
            ang.apply(scope, function() {
              scope.updateModel();
              ang.callAfter(function() {
                ang.apply(scope, function() {
                  scope.change();
                });
              }, scope);
            });
          });
        }
      };
    }
  ]);
  
  angular.module('cfn').directive('cfnInputMultilinestring', [
    '$rootScope',
    '$log',
    function($rootScope, $log) {
      return {
        restrict: 'E',
        scope: {
          model: '=',
          class: '@',
          readonly: '=',
          required: '@',
          change: '&'
        },
        replace: true,
        template:
          '<span style="width:200px;"><span style="width:180px;" ng-repeat="line in data"><input type="text" cfn-enter-tab ng-model="data[$index]"  style="width:150px;" ng-readonly="readonly" ng-required="{{required}}"/> <button class="btn imgOnly" ng-click="addRow();" ng-show="$index==0"><img src="img/bicons/black/add.png"/></button><button class="btn imgOnly" ng-click="removeRow($index);" ng-show="$index!=0"><img src="img/bicons/black/remove.png"/></button></span></span></span>',
        link: function(scope, element, attrs) {
          scope.doSave = function() {
            ang.apply(scope, function() {
              scope.updateModel();
              ang.callAfter(function() {
                ang.apply(scope, function() {
                  scope.change();
                });
              }, scope);
            });
          };
          scope.updateRows = function() {
            $('input', element)
              .off('change')
              .change(function() {
                //ang.delayedTimeout(scope,"$$updateTimer", function(){
                scope.doSave();
                //}, 100);
              });
          };
          scope.$watch('model', function(newVal) {
            if (newVal) {
              if (scope.model.indexOf('[') === 0) {
                scope.data = angular.fromJson(scope.model);
              } else {
                scope.data = [scope.model];
              }
            } else {
              scope.data = [''];
            }
            ang.callAfter(function() {
              scope.updateRows();
            }, scope);
          });
          scope.addRow = function() {
            scope.data.push('');
            ang.callAfter(function() {
              scope.updateRows();
              $('input:last', element).focus();
            }, scope);
          };
          scope.removeRow = function(index) {
            scope.data.splice(index, 1);
            scope.doSave();
          };
  
          scope.updateModel = function() {
            console.debug(' updated data ', scope.data);
            scope.model = angular.toJson(scope.data);
          };
        }
      };
    }
  ]);
  
  (function() {
    var inputInteger = 'cfnInputInteger';
    var inputDouble = 'cfnInputDouble';
    var inputArea = 'cfnInputArea';
  
    registerNumericInputDirective(inputInteger);
    registerNumericInputDirective(inputDouble);
    registerNumericInputDirective(inputArea);
  
    function registerNumericInputDirective(inputType) {
      angular.module('cfn').directive(inputType, [
        '$rootScope',
        '$log',
        'unitConverter',
        'userSettingsService',
        '$locale',
        function($rootScope, $log, unitConverter, userSettingsService, $locale) {
          return {
            restrict: 'E',
            scope: {
              model: '=',
              class: '@',
              readonly: '=',
              required: '@',
              param: '@', //display decimal places
              noDecimalZeroPadding: '@', // Disables padding of number decimals with zeros at the end, this is a flag, values doesn't matter
              useParam: '@', //display decimal places set in param value for inputArea instead of userSettingsService.getAreaUnitEnum
              symbolPre: '@',
              symbolPost: '@',
              symbolPostSingular: '@',
              defaultValue: '@',
              unitFactor: '@',
              vMin: '@',
              vMax: '@',
              change: '&',
              asep: '=' // thousands separator
            },
            replace: true,
            template:
              '<input style="text-align:right" type="text" cfn-enter-tab ng-class="{\'validate[required]\':required&&(readonly!=true)}" class="{{class}}" ng-readonly="readonly" ng-required="{{required}}"/>',
            // TODO: Compare with https://gist.github.com/kwokhou/5964296
            // 		 - fromUser/toUser could be handled by auto-numeric?
            //		 - check if auto-caluclated currency fields still work
            link: function(scope, element, attrs, ngModel, $parse) {
              $log.warn(
                'The directive ' +
                  inputType +
                  ' is deprecated. Please upgrade to ' +
                  inputType.replace('cfn', 'd')
              );
  
              if (!scope.param) {
                scope.param = 2;
              }

              if (inputType == inputInteger) {
                scope.param = 0;
              } else if (inputType == inputArea && !scope.useParam) {
                scope.param = unitConverter.unitDefaultDecimals(
                  userSettingsService.getAreaUnitEnum()
                );
              }

              /* Note: the autonumeric makes some things very complex. you need to update into both directions !*/
              /* Autonumeric is a jquery plugin: http://www.decorplanit.com/plugin/ */
              var autoNumOptions = {
                aSep:
                  typeof scope.asep !== 'undefined'
                    ? scope.asep
                    : $locale.NUMBER_FORMATS.GROUP_SEP,
                aDec: $locale.NUMBER_FORMATS.DECIMAL_SEP,
                mDec: scope.param,
                vMin: scope.vMin || '-9999999999999.99',
                vMax: scope.vMax || '999999999999999.99',
                aPad: scope.noDecimalZeroPadding
              };
              element.autoNumeric('init', autoNumOptions);
  
              var updateSymbol = function() {
                // check if the element does even exist anymore
                if (!element.autoNumeric('getSettings')) return;
                if (scope.symbolPre && scope.symbolPre.length > 0) {
                  element.autoNumeric('update', {
                    aSign: scope.symbolPre,
                    pSign: 's'
                  });
                } else {
                  if (scope.symbolPost && scope.symbolPost.length > 0) {
                    if (
                      scope.symbolPostSingular &&
                      scope.symbolPostSingular.length > 0 &&
                      scope.model == 1
                    ) {
                      // if there is a singular symbol and model value is 1, use singular
                      element.autoNumeric('update', {
                        aSign: ' ' + scope.symbolPostSingular,
                        pSign: 's'
                      });
                    } else {
                      // use plural / default symbol
                      element.autoNumeric('update', {
                        aSign: ' ' + scope.symbolPost,
                        pSign: 's'
                      });
                    }
                  } else {
                    element.autoNumeric('update', {
                      aSign: ''
                    });
                  }
                }
              };
  
              scope.$watch("symbolPre+' '+symbolPost", updateSymbol);
  
              if (attrs.model) {
                scope.set = function(value) {
                  ang.apply(scope, function() {
                    if (isNaN(value)) {
                      value = undefined;
                    }
                    scope.model = value;
                    //                        console.debug(scope.class+"="+scope.model);
                  });
                };
                scope.get = function() {
                  return scope.model;
                };
              }
  
              // update the model when the data is changed
  
              if (attrs.model) {
                var changeEventByKeyUp = false;
                var getUserdata = function(event) {
                  var changed = true;
                  ang.apply(scope, function() {
                    // convert the number from user space to model space
                    var v = element.autoNumeric('get');
                    v = parseFloat(v);
                    if (inputType == inputArea) {
                      //convert from model unit space (hectar) to user one
                      v = unitConverter.convert(
                        userSettingsService.getAreaUnitEnum(),
                        'AREAL_HA',
                        v
                      );
                    }
  
                    if (isNaN(v)) {
                      v = scope.default;
                    }
                    // check if the value was empty before. If it was empty allow nan and undefined to be equal
                    if (v === 0) {
                      if (scope.model === undefined || isNaN(scope.model)) {
                        changed = false;
                      }
                    }
  
                    if (!changed || scope.model == v) {
                      changed = false;
                    }
                    /*else
                                                    console.debug("change event with  change !"+scope.model+"->"+v,attrs.model);*/
                    scope.model = v;
                    // call change method
                    if (angular.isDefined(scope.change)) {
                      scope.change();
                    }
                  });
                  if (event === null) {
                    // event is a keyup event, no real change event
                    if (changed) changeEventByKeyUp = true;
                  } else if (changed || changeEventByKeyUp) {
                    // either if the change
                    ang.apply(scope, function() {
                      if (scope.change) scope.change();
                    });
                    //element.trigger("cfnChange"); // trigger special cfn change
                  } else {
                    return false;
                  }
                };
                element.change(getUserdata);
  
                var displayUpdate = function() {
                  //model got change update view
                  var val = scope.model;
  
                  if (isNaN(scope.model)) {
                    scope.model = undefined;
                  }
  
                  if (
                    scope.model === undefined &&
                    scope.defaultValue !== undefined &&
                    scope.defaultValue !== null
                  ) {
                    val = scope.model = scope.defaultValue;
                  }
  
                  // update symbol when there is a singular symbol that can be used
                  if (
                    scope.symbolPostSingular &&
                    scope.symbolPostSingular.length > 0
                  ) {
                    updateSymbol();
                  }
  
                  if (inputType == inputArea) {
                    //convert from user unit space to model one (hectar)
                    val = unitConverter.convert(
                      'AREAL_HA',
                      userSettingsService.getAreaUnitEnum(),
                      val
                    );
                  }
  
                  // if the model changes, update the  autonumeric value
                  if (val !== undefined && val !== null) {
                    try {
                      element.autoNumeric('set', val);
                    } catch (e) {
                      console.error(
                        'exception occured in input. Maybe scope is wrong? ' +
                          val,
                        e,
                        element,
                        element[0]
                      );
                      // Workaround: If used in a popup, a change of the shown element
                      // leads to an uninitialized component on which set
                      // must not be called. Catch this exception for now.
                      //                		element.autoNumeric('set',"");
                    }
                  } else {
                    try {
                      element.autoNumeric('set', '');
                    } catch (e) {
                      console.error(
                        'exception occured in input. Maybe scope is wrong? ' +
                          val,
                        e,
                        element,
                        element[0]
                      );
                      // Workaround: If used in a popup, a change of the shown element
                      // leads to an uninitialized component on which set
                      // must not be called. Catch this exception for now.
                      //                		element.autoNumeric('set',"");
                    }
                  }
                };
                var unwatchModel = scope.$watch('model', displayUpdate);
                if (attrs.unitFactor !== null && attrs.unitFactor !== '') {
                  scope.$watch('unitFactor', displayUpdate);
                }
              } // if model
            } // end link function
          };
        }
      ]);
    }
  })();
  
  angular.module('cfn').directive('cfnInputCurrency', [
    'companyFinanceService',
    'i18nFilter',
    function(companyFinanceService, i18nFilter) {
      return {
        restrict: 'E',
        replace: true,
        template: function(element, attrs) {
          var required = attrs.required ? 'true' : 'false';
  
          var cssClass = attrs.class;
          if (attrs.required && attrs.readonly !== true) {
            cssClass += ' validate[required]';
          }
  
          return (
            '<input style="text-align:right" type="text" cfn-enter-tab class="' +
            cssClass +
            '" ng-readonly="' +
            attrs.readonly +
            '" ng-required="' +
            required +
            '"/>'
          );
        },
        scope: {
          model: '=',
          change: '&'
        },
        link: function(scope, element, attributes) {
          var currency =
            ' ' +
            i18nFilter(
              'enums.UnitsCurrencyEnum.' + companyFinanceService.getCurrencyUnit()
            );
          var vMin = attributes.vMin !== undefined ? attributes.vMin : 0;
          var mDec = attributes.param !== undefined ? attributes.param : 2;
          element.autoNumeric('init', {
            aSep: '.',
            aDec: ',',
            aSign: currency,
            pSign: 's',
            wEmpty: 'sign',
            vMin: vMin,
            mDec: mDec
          });
          var userChangeToModel = false;
  
          scope.$watch('model', function(newVal) {
            // we don't want to set the autonumeric value when the user changes the input as this involves
            // the cursor jumping to the end.
            if (!userChangeToModel) {
              if (newVal !== undefined && newVal !== null) {
                try {
                  element.autoNumeric('set', newVal);
                } catch (err) {
                  console.error('Error updating the currency display:', err);
                }
              } else {
                element.autoNumeric('set', '');
              }
            }
          });
  
          element.change(function() {
            element.autoNumeric('set', scope.model);
          });
  
          element.on('keyup', function() {
            userChangeToModel = true;
            // The apply is needed so the flag for a userChange is used correctly in the watcher.
            ang.apply(scope, function() {
              scope.model = element.autoNumeric('get');
              scope.change();
            });
            userChangeToModel = false;
          });
        }
      };
    }
  ]);
  
  /**
   * Example with focused 4, blurred 2 decimals:
   * <input type="number" ng-model="scopeValue" cfn-input-decimal/>
   * Example with custom precision (focus and blurred):
   * <input type="number" ng-model="scopeValue" cfn-input-decimal="2"/>
   * Example with custom precision and custom blurred decimals:
   * <input type="number" ng-model="scopeValue"
   * 		cfn-input-decimal="4" cfn-blurred-decimals="2"/>
   */
  angular.module('cfn').directive('cfnInputDecimal', [
    '$parse',
    '$filter',
    function($parse, $filter) {
      return {
        require: 'ngModel',
        link: function(scope, element, attrs, ngModelController) {
          var options = {
              // decimals to show while focused
              modelDecimals: 4,
              // decimals to show while blurred
              blurredDecimals: 2
            },
            currentViewDecimals,
            parser = function(data) {
              // Hack: Support German number format
              data = data.replace(',', '.');
              var num = parseFloat(data);
  
              if (isNaN(num)) {
                // Make sure model is set to a number
                return undefined;
              } else {
                num = num < 99999999 ? num : 99999999;
                // Round to decimals allowed in model
                num = num.toFixed(options.modelDecimals);
                num = parseFloat(num);
              }
  
              // Setting model to num;
              return num;
            },
            formatter = function(num) {
              num = $filter('number')(num, currentViewDecimals);
              return num;
            };
  
          // Override precision using attributes
          if (attrs.cfnInputDecimal) {
            options.modelDecimals = parseInt(attrs.cfnInputDecimal);
            options.blurredDecimals = options.modelDecimals;
          }
          if (attrs.cfnBlurredDecimals) {
            options.blurredDecimals = parseInt(attrs.cfnBlurredDecimals);
            // Never show more precision than is saved
            if (options.blurredDecimals > options.modelDecimals) {
              options.blurredDecimals = options.modelDecimals;
            }
          }
  
          currentViewDecimals = options.blurredDecimals;
  
          element.bind('focus', function() {
            currentViewDecimals = options.modelDecimals;
            element.val(formatter(ngModelController.$modelValue));
          });
  
          element.bind('blur', function() {
            currentViewDecimals = options.blurredDecimals;
            element.val(formatter(ngModelController.$modelValue));
          });
  
          ngModelController.$formatters.push(formatter);
          ngModelController.$parsers.push(parser);
        }
      };
    }
  ]);
  
  angular.module('cfn').directive('cfnInputBoolean', [
    '$rootScope',
    '$log',
    function($rootScope, $log) {
      return {
        restrict: 'E',
        scope: {
          model: '=',
          class: '@',
          readonly: '=',
          change: '&'
        },
        replace: true,
        template:
          '<input type=checkbox cfn-enter-tab ng-model="model" class="{{class}}"  ng-readonly="readonly" ng-disabled="readonly"/>',
        link: function(scope, element, attrs) {
          // call change event
          $(element).change(function() {
            // callafter is used because we need to ensure that the model has been set before
            ang.callAfter(function() {
              if (scope.change) scope.change();
            }, scope);
          });
        }
      };
    }
  ]);
  
  // Requires equality of two input fields
  // http://stackoverflow.com/a/21992003/50777
  angular.module('cfn').directive('nxEqualEx', function() {
    return {
      require: 'ngModel',
      link: function(scope, elem, attrs, model) {
        if (!attrs.nxEqualEx) {
          console.error('nxEqualEx expects a model as an argument!');
          return;
        }
        scope.$watch(attrs.nxEqualEx, function(value) {
          // Only compare values if the second ctrl has a value.
          if (model.$viewValue !== undefined && model.$viewValue !== '') {
            model.$setValidity('nxEqualEx', value === model.$viewValue);
          }
        });
        model.$parsers.push(function(value) {
          // Mute the nxEqual error if the second ctrl is empty.
          if (value === undefined || value === '') {
            model.$setValidity('nxEqualEx', true);
            return value;
          }
          var isValid = value === scope.$eval(attrs.nxEqualEx);
          model.$setValidity('nxEqualEx', isValid);
          return isValid ? value : undefined;
        });
      }
    };
  });
